import ludoPolyProject from "./projects/LudoPoly";
import findIt3DProject from "./projects/FindIt3d";
import arcticaProject from "./projects/Aractica";
import pieceBuilderProject from "./projects/PieceBuilder";

export default [
  ludoPolyProject,
  findIt3DProject,
  arcticaProject,
  pieceBuilderProject,
];
